import { post } from "src/services/api";

const GENERATE_SPEECH_ENDPOINT = "/assistants/generate-speech";
const ADMIN_GENERATE_SPEECH_ENDPOINT = "/v2/admin/assistants/generate-speech";

const generateSpeech = async ({ text, voiceNames, language, speakingRate, isAdmin = false, signal }) => {
  const payload = {
    voiceNames,
    text,
    language,
    speakingRate: speakingRate ?? 1.0,
  };

  const endpoint = isAdmin ? ADMIN_GENERATE_SPEECH_ENDPOINT : GENERATE_SPEECH_ENDPOINT;
  const response = await post({ endpoint, data: payload, responseType: "arraybuffer", signal });

  const audioBlob = new Blob([response], { type: "audio/wav" });
  return audioBlob;
};

export default {
  generateSpeech
};

